<template>
  <div class="text-field-wrapper">
    <form @submit.prevent="submitHandler()">
      <div
        v-if="this.getIsOtherCustomHPL"
        class="text-field-container"
        v-bind:class="{ 'error-style': hasErrorManufacturer }"
      >
        <label for="Manufacturer"> Manufacturer*</label>
        <input
          :placeholder="this.getcustomHPLData.ManufacturerPlaceholder"
          name="manufacturer"
          :maxlength="40"
          v-on:keypress="removeErrorStateManufacturer()"
          v-on:keyup.delete="removeErrorStateManufacturer()"
          :value="manufacturer"
          ref="input_manufacturer"
          tabindex="0"
          aria-label="Manufacturer Name"
          autocomplete="off"
        />

        <a
          class="reference-text-container"
          :href="this.getcustomHPLData.ReferenceUrl"
          target="_blank"
          rel="noopener noreferrer"
          tabindex="-1"
        >
          <span class="material-icons-outlined tool-tip-icon">info</span>
          <span class="tool-tip-icon-text">
            {{ this.getcustomHPLData.ReferenceText }}
          </span>
        </a>
        <span class="error-text"> Please enter a manufacturer.</span>
      </div>

      <div
        class="text-field-container"
        v-bind:class="{ 'error-style': hasErrorColorName }"
      >
        <label for="ColorName"> Color Name*</label>
        <input
          :placeholder="this.getcustomHPLData.ColorNamePlaceholder"
          name="colorName"
          :maxlength="40"
          v-on:keypress="removeErrorStateColorName()"
          v-on:keyup.delete="removeErrorStateColorName()"
          :value="colorName"
          ref="input_color_name"
          tabindex="0"
          aria-label="Color Name"
          autocomplete="off"
        />

        <a
          class="reference-text-container"
          :href="this.getcustomHPLData.ReferenceUrl"
          target="_blank"
          rel="noopener noreferrer"
          tabindex="-1"
        >
          <span class="material-icons-outlined tool-tip-icon">info</span>
          <span class="tool-tip-icon-text">
            {{ this.getcustomHPLData.ReferenceText }}
          </span>
        </a>
        <span class="error-text"> Please enter a color name.</span>
      </div>
      <div
        class="text-field-container"
        v-bind:class="{ 'error-style': hasErrorColorNumber }"
      >
        <label for="">Color Number*</label>
        <input
          name="colorNumber"
          :placeholder="this.getcustomHPLData.ColorNumberPlaceholder"
          :maxlength="10"
          v-on:keypress="removeErrorStateColorNumber()"
          v-on:keyup.delete="removeErrorStateColorNumber()"
          oninput="javascript :if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
          :value="colorNumber"
          ref="input_color_number"
          tabindex="0"
          aria-label="Color Number"
          autocomplete="off"
        />       
        <span class="error-text"> Please enter a color number.</span>
        <p class="toolTipHPLColorNote">{{ this.getcustomHPLData.ColorNumberNote}}</p>
      </div>
      <div class="apply-btn-container">
        <!-- Custom HPL Text apply button -->
        <button
          id="CustomHPLOptionTextFieldBtn"
          type="submit"
          class="text-field-apply-selection-btn"
          tabindex="0"
          aria-label="Apply"
        >
          Apply Selection
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  data() {
    return {
      colorName: "",
      colorNumber: "",
      manufacturer: "",
      hasErrorColorName: false,
      hasErrorColorNumber: false,
      hasErrorManufacturer: false
    };
  },
  computed: {
    ...mapGetters("enhancedproduct", [
      "getcustomHPLData",
      "getSelectedOptions",
      "getcustomHPLData",
      "getcustomHPLFormData",
      "getIsOtherCustomHPL"
    ])
  },
  methods: {
    ...mapActions("enhancedproduct", [
      "setIsCustomHPL",
      "setCustomHPLData",
      "setCustomHPLFormData",
      "setIsOtherCustomHPL"
    ]),
    // Getting the form values and setting it to the local component variable
    setFormValues() {
      const colorName = this.$refs.input_color_name.value;
      const colorNumber = this.$refs.input_color_number.value;
      this.colorName = colorName;
      this.colorNumber = colorNumber;
      if (this.getIsOtherCustomHPL) {
        const manufacturer = this.$refs.input_manufacturer.value;
        this.manufacturer = manufacturer;
      }
    },
    // Functions to listen for typing/delete key and remove error states
    removeErrorStateColorName() {
      this.setFormValues();
      this.hasErrorColorName = false;
    },
    removeErrorStateColorNumber() {
      this.setFormValues();
      this.hasErrorColorNumber = false;
    },
    removeErrorStateManufacturer() {
      this.setFormValues();
      this.hasErrorManufacturer = false;
    },
    // Submit handler to validate and show the error states or submit the data
    submitHandler() {
      this.setFormValues();
      const colorName = this.colorName;
      const colorNumber = this.colorNumber;
      const manufacturer = this.manufacturer;

      if (this.getIsOtherCustomHPL) {
        if (
          !/^(?!\s*$)[A-Za-z0-9- .]+$/.test(colorName) ||
          !/^(?!\s*$)[A-Za-z0-9- .]+$/.test(colorNumber) ||
          !/^(?!\s*$)[A-Za-z0-9- .]+$/.test(manufacturer)
        ) {
          if (!/^(?!\s*$)[A-Za-z0-9- .]+$/.test(colorName)) {
            this.hasErrorColorName = true;
          }
          if (!/^(?!\s*$)[A-Za-z0-9- .]+$/.test(colorNumber)) {
            this.hasErrorColorNumber = true;
          }
          if (!/^(?!\s*$)[A-Za-z0-9- .]+$/.test(manufacturer)) {
            this.hasErrorManufacturer = true;
          }
        } else {
          this.colorName = colorName;
          this.colorNumber = colorNumber;
          this.manufacturer = manufacturer;
          this.$store.dispatch("enhancedproduct/setCustomHPLFormData", {
            Id: this.getcustomHPLData.Id,
            RulesKey: this.getcustomHPLData.RulesKey,
            ColorName: colorName,
            ColorNumber: colorNumber,
            Manufacturer: manufacturer
          });
          this.$store.dispatch("enhancedproduct/setIsCustomHPL", false);
          this.$store.dispatch("enhancedproduct/setIsOtherCustomHPL", false);
        }
      } else {
        if (
          !/^(?!\s*$)[A-Za-z0-9- .]+$/.test(colorName) ||
          !/^(?!\s*$)[A-Za-z0-9- .]+$/.test(colorNumber)
        ) {
          if (!/^(?!\s*$)[A-Za-z0-9- .]+$/.test(colorName)) {
            this.hasErrorColorName = true;
          }
          if (!/^(?!\s*$)[A-Za-z0-9- .]+$/.test(colorNumber)) {
            this.hasErrorColorNumber = true;
          }
        } else {
          this.colorName = colorName;
          this.colorNumber = colorNumber;
          this.$store.dispatch("enhancedproduct/setCustomHPLFormData", {
            Id: this.getcustomHPLData.Id,
            RulesKey: this.getcustomHPLData.RulesKey,
            ColorName: colorName,
            ColorNumber: colorNumber
          });
          this.$store.dispatch("enhancedproduct/setIsCustomHPL", false);
        }
      }
    }
  },
  mounted() {
    // Showing the user entered data appropriately in the form
    if (this.getcustomHPLFormData.length > 0) {
      let formRulesKey = this.getcustomHPLData.RulesKey;
      let formId = this.getcustomHPLData.Id;
      for (let i = 0; i < this.getcustomHPLFormData.length; i++) {
        if (
          this.getcustomHPLFormData[i].RulesKey === formRulesKey &&
          this.getcustomHPLFormData[i].Id === formId
        ) {
          this.colorName = this.getcustomHPLFormData[i].ColorName;
          this.colorNumber = this.getcustomHPLFormData[i].ColorNumber;
          this.manufacturer = this.getcustomHPLFormData[i].Manufacturer;
        }
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.text-field-wrapper {
  padding-top: 5px;
}
.reference-text-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  margin-top: 5px;
}
.reference-link-text {
  color: #666766;
  font-size: 16px;
  display: inline-block;
  max-width: 100%;
  margin-bottom: 5px;
  font-weight: bold;
  font-family: $font-weight-bold;
}
.reference-link {
  color: #134896;
  font-size: 13px;
}
.text-field-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding-bottom: 20px;
  label {
    color: rgb(102, 103, 102);
    font-size: 14px;
    font-family: $font-family-sans-serif-regular;
    letter-spacing: 0.25px;
    font-weight: normal;
    margin-bottom: 12px;
  }
  input {
    width: 100%;
    height: 49px;
    display: -webkit-flex;
    display: flex;
    -webkit-align-items: center;
    align-items: center;
    position: relative;
    padding: 15px 10px;
    background-color: #ffffff;
    transition: all 0.2s ease 0s;
    color: #333333;
    border: 1px solid rgb(153, 153, 153);
    border-radius: 0;
    outline-offset: 2px;
    font-family: $font-family-sans-serif-regular;
    font-size: 16px !important;
    letter-spacing: 0.25px;
  }
  .error-text {
    display: none;
  }
}
.error-style {
  input {
    border: 1px solid rgb(204, 0, 0);
  }
  .error-text {
    display: flex;
    color: rgb(204, 0, 0);
    font-size: 12px;
    font-family: $font-weight-medium;
    font-weight: 500;
    letter-spacing: 0.5px;
    margin-top: 5px;
  }
  .reference-text-container {
    display: none;
  }
}
::-webkit-input-placeholder {
  /* Chrome/Opera/Safari */
  height: 21px !important;
  color: rgb(153, 153, 153) !important;
  font-size: 16px;
  font-family: $font-family-sans-serif-regular !important;
  letter-spacing: 0.25px !important;
}
::-moz-placeholder {
  /* Firefox 19+ */
  height: 21px !important;
  color: rgb(153, 153, 153) !important;
  font-size: 16px !important;
  font-family: $font-family-sans-serif-regular !important;
  letter-spacing: 0.25px !important;
}
.apply-btn-container {
  display: flex;
  justify-content: center;
}
.text-field-apply-selection-btn {
  position: relative;
  bottom: 10px;
  margin: 0 0 10px 0;
  background: rgb(37, 192, 208);
  border: 1px solid transparent;
  box-shadow: 0px 2px 11px 5px rgba(0, 0, 0, 0.1);
  padding: 12px 30px 10px;
  color: #fff;
  text-transform: uppercase;
  font-family: $font-weight-bold;
  font-size: 16px;
  letter-spacing: 0.75px;
  min-width: 220px;
  &:hover,
  &:focus {
    color: #25c0d0;
    background-color: #fff;
    border-color: #25c0d0;
  }
  @include media-breakpoint-up(md) {
    bottom: 10px;
  }
}
.ie-11 .text-field-apply-selection-btn {
  @include media-breakpoint-down(md) {
    transform: none;
    left: 50%;
    margin-left: -110px;
  }

  @include media-breakpoint-up(md) {
    transform: translate(35%, -50%);
  }
}
.tool-tip-icon {
  color: rgb(37, 192, 208);
  font-size: 16px;
  font-weight: normal;
  height: 16px;
  letter-spacing: 0px;
  width: 16px;
}
.tool-tip-icon-text {
  color: rgb(51, 51, 51);
  font-size: 12px;
  font-family: $font-weight-medium;
  font-weight: 600;
  letter-spacing: 0.5px;
  padding-left: 5px;
}
.toolTipHPLColorNote {  
  font-family: "FFDINWebPro", Helvetica, Arial, sans-serif; 
  font-size: 13px; 
}
</style>
